import React from 'react';
import { InlineTextInput } from 'src/modules/shared/components/molecules/inputs/inline/inline-text-input';

interface TaskObjectiveInputProps {
  value: string;
  onSave: (value: string) => Promise<void>;
  disabled?: boolean;
  isFinished?: boolean;
  size?: 'sm' | 'md' | 'lg';
  placeholder?: string;
}

/**
 * Shared component for task objective editing
 */
export const TaskObjectiveInput: React.FC<TaskObjectiveInputProps> = ({
  value,
  onSave,
  disabled = false,
  isFinished = false,
  size = 'sm',
  placeholder = '',
}) => {
  return (
    <InlineTextInput
      label=""
      value={value}
      onSave={onSave}
      formatDisplayValue={(value) => value}
      disableCopy
      alignment="left"
      buttonLabelClassName={`w-full ${
        isFinished ? 'line-through text-primary-400' : ''
      }`}
      disabled={disabled}
      size={size}
      placeholder={placeholder}
    />
  );
};
